/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import { Article } from '../cards';

import styles from '../../../styles/blocks/article.module.scss';

const propTypes = {
    article: AppPropTypes.article,
    isContainer: PropTypes.bool,
    className: PropTypes.string,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    article: null,
    isContainer: false,
    className: null,
    containerClassName: null,
};

const ArticleBlock = ({ article, isContainer, className, containerClassName }) => {
    if (article === null) return null;

    return (
        <div
            className={classNames({
                [styles.container]: true,
                [className]: className !== null,
            })}
        >
            <div
                className={classNames([
                    'blockArticle',
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                <Article className={styles.card} item={article} />
            </div>
        </div>
    );
};

ArticleBlock.propTypes = propTypes;
ArticleBlock.defaultProps = defaultProps;

export default ArticleBlock;
